export default __webpack_public_path__ + "static/media/Switzerland.5b8f4f70.jpg";